import { Project, User, UserForResolver } from "db/definitions";
import { deleteProject } from "../db/queries/projectQueries";
import _getProject from "./_getProject";
import deleteProjectFromDb from "./deleteProjectFromDb";
import { recordSentry } from "./recordSentry";
import handleProjectBackup from "./handleProjectBackup";

async function handleDeleteProject(project: Project, user: UserForResolver, online: boolean) {
	try {
		if (online) {
			const backupSuccess = await handleProjectBackup(project, user, online);
			if (backupSuccess) {
				await deleteProjectFromDb(project.id, online);
			} else {
				throw new Error("Project backup failed, aborting deletion.");
			}
		} else {
			await deleteProject(project);
		}
	} catch (error) {
		recordSentry({ error, msg: "Error deleting project: " });
	}
}

export default handleDeleteProject;
